const operationPackageEn = {
  sideBar: {
    close: "Close side tab",
  },
  addPattern: {
    addButtonLabel: "Add operation package pattern",
    success: "Operation package pattern created successfully",
    error: "Failed to create operation package pattern",
  },
  addPersonDialog: {
    title: "Create new",
    description: "Create a new person",
  },
};

export default operationPackageEn;
